import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { Observable, Subject, takeUntil } from 'rxjs';
import { EnvironmentService } from 'src/app/cloud-subscription/services/environment.service';
import { ExternalLinks } from 'src/app/interfaces/environment.interface';
import { CloudNotificationStyle } from 'src/app/models/cloud-notification-style.model';
import { CloudAuthenticationService } from 'src/app/services/cloud-authentication.service';
import { CloudHelpService } from 'src/app/services/cloud-help.service';
import { CloudNotificationService } from 'src/app/services/cloud-notification.service';
import Helper from 'src/app/Util/helper';

@Component({
  selector: 'app-help-panel',
  templateUrl: './help-panel.component.html',
  styleUrls: ['./help-panel.component.sass']
})
export class HelpPanelComponent implements OnInit {
  private openedWindows: { [key: string]: Window | null } = {};
  private unsubscribe$ = new Subject<void>()
  faTimes = faTimes;
  links : ExternalLinks 

  constructor(private helpPanelService : CloudHelpService,private environmentService: EnvironmentService,private notificationService: CloudNotificationService, private authService:CloudAuthenticationService ){}
  isHelpPanelOpened : boolean = false

  ngOnInit(): void {
    this.observeHelpPanel()
    this.getExternalLinks()
  }


  private observeHelpPanel(){
    this.helpPanelService.helpPanelDispalyStatus.subscribe(_ =>{
      this.isHelpPanelOpened = _
    })
  }


  closePanel(event: Event): void {
    this.helpPanelService.helpPanelDispalyStatus.next(false)
  }

  

  private getExternalLinks(): void {
    this.authService.authenticationStatus.subscribe(a=>{
      if(a){
        this.environmentService.getExternalLinks().pipe(takeUntil(this.unsubscribe$)).subscribe({

          next: (links) => {
            this.links = links
          },
    
          error: (err: HttpErrorResponse) => {
            this.notificationService.createToastNotification('get-external-links', Helper.resolveErrorMessage(err), CloudNotificationStyle.danger)
          }
    
        });
      }
    })
}

openOrFocusWindow(link: string): void {

  if (!this.openedWindows[link] || this.openedWindows[link]?.closed) {
    this.openedWindows[link] = window.open(link, `manageWindow-${link}`);
  } else {
    this.openedWindows[link]?.focus();
  }
}



}
